<ng-container *transloco="let t;">
  <div class="card-header">
    <h4 class="card-title font-medium-1">{{ t('Email bounced (Dashboard email bounced widget title) - Email bounced') }}</h4>
  </div>
  <div class="card-body">
    @for(bouncedDocument of (bouncedDocuments$ | async); track bouncedDocument){
      <div class="transaction-item">
        <div class="media align-items-center">
          <div class="avatar bg-light-danger rounded">
            <div class="avatar-content">
              <i class="feather font-medium-3 icon-mail"></i>
            </div>
          </div>
          <div class="media-body">
            <h6 class="transaction-title activity-Links-h6"><a class="activity-Links" [routerLink]="['/documents']" [state]="{query:bouncedDocument.document_number,document_id:bouncedDocument.id}">{{bouncedDocument.name}}</a></h6>
            <p class="text-muted mb-0 font-small-3">{{ bouncedDocument?.document_type?.document_type }} - {{ bouncedDocument?.recipient_roles[0]?.user?.name }}</p>
          </div>
        </div>
        <div><small class="text-muted">{{ bouncedDocument.updated_at | dateConversationPipe | async }}</small></div>
      </div>
    }@empty {
      <div class="mb-1 p-4 mt-1 text-center cc-no-recordsDiv">
        <p class="text-muted mb-0">{{ t('No records (general) - No records') }}</p>
      </div>
    }
  </div>
</ng-container>